<template lang="pug">
  Auth
    NowLoading(:show="underLoading")
    div.sign-in
      ModuleSignIn
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.sign-in {
  width: 100%;
  height: 100vh;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')

import Auth from '@/components/shared/Auth'
import NowLoading from '@/components/shared/NowLoading'
import ModuleSignIn from '@/components/module/ModuleSignIn'

export default {
  components: {
    Auth,
    NowLoading,
    ModuleSignIn
  },
  computed: {
    ...mapState(['underLoading'])
  }
}
</script>